import {
  SET_ME,
  SET_DOCUMENTS_LOADING,
  SET_DOCUMENTS,
  SET_MEMBER_STATS,
} from '~/store/me/mutation-types';

export default {
  /**
   * Mutate the me.me state
   * @param state
   * @param payload
   */
  [SET_ME](state, payload) {
    // not for now because it causes infinite loop (conflict with the /members store)
    // this.$auth.setUser(payload);
    state.me = payload;
  },

  /**
   * Mutate the me.stats state
   * @param state
   * @param payload
   */
  [SET_MEMBER_STATS](state, payload) {
    state.stats = payload;
  },

  /**
   * Mutate the me.loading state
   * @param state
   * @param payload
   */
  [SET_DOCUMENTS_LOADING](state, payload) {
    state.loading = payload;
  },
  /**
   * Mutate the me.documents state
   * @param state
   * @param payload
   */
  [SET_DOCUMENTS](state, payload) {
    state.documents = payload;
  },
};
